<template>
    <DataTable
            v-redirect-if-no-permission:SERVICES
            v-if="name" :url="api.ACTIONS.SERVICE_CARS(id)"
            descending
            :titles="titles"
            :title='$t("catalogPage.attachedCaptainsTitle", { name })'
            :enable-edit="false"
            :forceReload="true"
            :enable-delete="false"
            :fields-hidden-main="['deleted_at','created_at','updated_at','brand_model_id','color_id', 'captain_id',  'pivot', 'car_picture']"
            :fields-hidden-add="['id', 'plate_number','captain','brand', 'car_brand_id','model','color','insurance_expired_date','car_manufacture_year','number','insurance_document',
               'car_document','captain_id','color_id','brand_model_id','approved','deny_reason','deleted_at','created_at','updated_at','pivot','car_picture', 'has_owner']"
            :fields-extra-add="fieldsExtraAdd"
            :selected-actions="selectedActions"
            :selectable="'Select'"
            :formatter="formatter"
    ></DataTable>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "ServiceCars",
        title() {
            return this.$t("catalogPage.pageTitleCars");
        },
        components: {DataTable},
        data() {
            return {
                id: null,
                name: null
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.name = this.$route.query.name || this.$t("catalogPage.unknown");
        },
        computed: {
            formatter() {
                return {
                    created_at: (val) => this.$companyTime(val, 'MMM DD YYYY'),
                    updated_at: (val) => this.$companyTime(val, 'MMM DD YYYY'),
                }
            },
            titles() {
                return {
                    id: "#",
                    plate_number: this.$t("catalogPage.colPlateNumber"),
                    car_manufacture_year: this.$t("catalogPage.colManuYear"),
                    color: this.$t("catalogPage.colColor"),
                    captain: this.$t("catalogPage.colCaptain"),
                    brand: this.$t("catalogPage.colBrand"),
                    model: this.$t("catalogPage.colModel"),
                    captains: this.$t("catalogPage.chooseCaptain")
                }
            },
            fieldsExtraAdd() {
                return {
                    captains: "choose-captains-multi"
                }
            },
            selectedActions() {
                return {
                    "Delete": {
                        color: "error",
                        title: this.$t("catalogPage.delete"),
                        do: async (items) => {
                            try {
                                let params = new URLSearchParams();
                                let index = 0;
                                for (let item of items) params.append("captains[" + (index++) + "]", item.id);
                                await this.axios.delete(this.api.ACTIONS.SERVICES + "/" + this.id + "/cars?" + params.toString());
                                window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.deleted"), "green");
                                return {
                                    shouldClearSelected: true,
                                    shouldReloadData: true
                                }
                            } catch (e) {
                                window.getApp.$emit("SHOW_TOAST", this.$t("catalogPage.failed"), "red");
                            }

                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
